import { render, staticRenderFns } from "./TransferNanny.vue?vue&type=template&id=ae813a6e&scoped=true"
import script from "./TransferNanny.vue?vue&type=script&lang=js"
export * from "./TransferNanny.vue?vue&type=script&lang=js"
import style0 from "./TransferNanny.vue?vue&type=style&index=0&id=ae813a6e&prod&lang=css"
import style1 from "./TransferNanny.vue?vue&type=style&index=1&id=ae813a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae813a6e",
  null
  
)

export default component.exports